module.exports = __webpack_public_path__ + "img/patuah_no.d1aa1876.png";